import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useMediaQuery from "../../utils/hooks/use-media-query";
import "./mobile-admin-navigation.scss";

export const adminNavigationGroups = [
  { label: "admin catalog", routes: [
    { path: "/admin", label: "admin shapes" },
    { path: "/admin/steel-types", label: "admin steel" },
  ] },
  { label: "admin activity", routes: [
    { path: "/admin/user-analytics", label: "admin analytics" },
    { path: "/admin/live-users", label: "admin live users" },
  ] },
  { label: "admin business", routes: [
    { path: "/admin/supplier-tickets", label: "admin tickets" },
    { path: "/admin/bids-calculator", label: "admin bids" },
  ] },
];

export default function MobileAdminNavigation({ role, language }: { role?: number; language: string }) {
  const mobile = useMediaQuery("(max-width: 991.98px)");
  const { pathname } = useLocation();
  const { t } = useTranslation("common");
  const [open, setOpen] = useState(false);
  const label = (key: string) => t(key, { lng: language });
  const direction = language === "he" ? "rtl" : "ltr";
  const current = adminNavigationGroups.flatMap(group => group.routes)
    .find(route => route.path === pathname.replace(/\/$/, ""));

  useEffect(() => { setOpen(false); }, [pathname, mobile]);
  if (!mobile || role !== 0) return null;

  return <>
    <header className="admin-mobile-header" dir={direction}>
      <button type="button" aria-label={label("admin open navigation")} aria-expanded={open}
        aria-controls="admin-mobile-navigation" onClick={() => setOpen(true)}>☰</button>
      <div><span>{label("admin panel")}</span><strong>{label(current?.label || "admin panel")}</strong></div>
      <NavLink to="/new-order">{label("admin application")}</NavLink>
    </header>
    <Modal show={open} onHide={() => setOpen(false)} className="admin-navigation-modal" dialogClassName={`admin-mobile-drawer admin-mobile-drawer-${direction}`}
      aria-labelledby="admin-mobile-navigation-title" backdrop keyboard restoreFocus>
      <div className="admin-mobile-drawer-content" dir={direction}>
        <header>
          <h2 id="admin-mobile-navigation-title">{label("admin panel")}</h2>
          <button type="button" aria-label={label("admin close navigation")} onClick={() => setOpen(false)}>×</button>
        </header>
        <nav id="admin-mobile-navigation" aria-label={label("admin navigation")}>
          {adminNavigationGroups.map(group => <section key={group.label}>
            <h3>{label(group.label)}</h3>
            {group.routes.map(route => <NavLink exact key={route.path} to={route.path}
              activeClassName="is-active" onClick={() => setOpen(false)}>{label(route.label)}</NavLink>)}
          </section>)}
        </nav>
      </div>
    </Modal>
  </>;
}
